import moment from 'moment';
import React from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';

const CondicaoEspecial = ({ condicoesEspeciais }) => {
  if (!condicoesEspeciais) return null;

  const {
    descricao,
    is_isencao,
    financiamento,
    saldo_correcao,
    valor_lote,
    status,
    valor_avaliacao_bancaria,
    ocorrencias,
    codigo_sis_status_ativo,
    codigo,
  } = condicoesEspeciais.condicoes;
  const aprovador = condicoesEspeciais.aprovador;

  return (
    <>
      <Card.Title className="mb-4">
        #{codigo} - Condição Especial - Aprovado por: {aprovador}
      </Card.Title>

      <Row className="mb-3">
        <Col>
          <strong>Descrição:</strong>
          <br />
          {descricao}
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <strong>Isenção:</strong>
          <br />
          {is_isencao ? (
            <Badge bg="success">Sim</Badge>
          ) : (
            <Badge bg="secondary">Não</Badge>
          )}
        </Col>
        {!!(financiamento && financiamento.prazo_financiamento_meses) && (
          <>
            <Col md={6}>
              <strong>Carência entre sinal e fin.(Meses):</strong>
              <br />
              {financiamento && financiamento.prazo_financiamento_meses}
            </Col>
          </>
        )}
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <strong>Valor Sugerido:</strong>
          <br />
          {valor_lote && valor_lote.valor_sugerido
            ? `R$ ${valor_lote.valor_sugerido.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}`
            : '-'}
        </Col>
        <Col md={6}>
          <strong>Desconto (%):</strong>
          <br />
          {valor_lote && valor_lote.porcentagem_desconto
            ? `${valor_lote.porcentagem_desconto.toFixed(2)}%`
            : '-'}
        </Col>
      </Row>

      {!!saldo_correcao && (
        <>
          <Row className="mb-3">
            <Col md={6}>
              {!!saldo_correcao.valor_saldo_correcao && (
                <>
                  {' '}
                  <strong>Saldo correção:</strong>
                  <br />
                  {`R$ ${saldo_correcao.valor_saldo_correcao.toLocaleString(
                    'pt-BR',
                    {
                      minimumFractionDigits: 2,
                    }
                  )}`}
                </>
              )}
            </Col>
            {saldo_correcao && saldo_correcao.data_saldo && (
              <>
                <Col md={6}>
                  <strong>Data saldo:</strong>
                  <br />
                  {moment(saldo_correcao.data_saldo).format('MM/YYYY')}
                </Col>
              </>
            )}
          </Row>
        </>
      )}
    </>
  );
};

export default CondicaoEspecial;
